<template>
  <router-view></router-view>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  async created(){
    // console.log('App created', localStorage.getItem('token'));
      if(
        this.$store.state.auth.token == null || this.$store.state.auth.token == "null" || this.$store.state.auth.token == undefined || this.$store.state.auth.token == 'undefined'
      ){
        const ls_token = localStorage.getItem('token');
        if(typeof ls_token === 'string' && ls_token.length > 0){
          console.log('App ls_token login', ls_token);
          this.loadAccount(ls_token);
        }else{
          // this.$router.push({ path: '/logout' });
        }
      }
      else if(
        (
        this.$store.state.auth.userId == null || this.$store.state.auth.userId == 'null'
          || this.$store.state.auth.userId == false || this.$store.state.auth.userId == 'false'
          || this.$store.state.auth.userId == undefined || this.$store.state.auth.userId == 'undefined'
        ) && (this.$store.state.auth.token != null && this.$store.state.auth.token != "null" && this.$store.state.auth.token != undefined && this.$store.state.auth.token != 'undefined' && this.$store.state.auth.token != '')
      ){
        console.log('app created login tokenだけ', this.$store.state.auth.token);
        this.loadAccount(this.$store.state.auth.token);
      }
      else{
        console.log('app check page getMyData!!! loginしてる', this.$store.state.auth);
      }
      
      // if(
      //   this.$store.state.auth.token == null || this.$store.state.auth.token == "null" || this.$store.state.auth.token == undefined || this.$store.state.auth.token == 'undefined'
      // ){
      //   this.$router.push({ path: '/logout' });
      // }
      // else if(
      //   (
      //   this.$store.state.auth.userId == null || this.$store.state.auth.userId == 'null'
      //     || this.$store.state.auth.userId == false || this.$store.state.auth.userId == 'false'
      //     || this.$store.state.auth.userId == undefined || this.$store.state.auth.userId == 'undefined'
      //   ) && (this.$store.state.auth.token != null || this.$store.state.auth.token != "null" || this.$store.state.auth.token != undefined || this.$store.state.auth.token != 'undefined')
      // ){
      //   console.log('app created login tokenだけ', this.$store.state.auth.token);
      //   this.loadAccount(this.$store.state.auth.token);
      // }
      // else{
      //   console.log('app check page getMyData!!! loginしてる', this.$store.state.auth);
      // }
      console.log('app check page getMyData!!! logout', this.$store.state.auth);
      document.documentElement.setAttribute('lang', 'ja');

  },
  // created: () => (document.documentElement.setAttribute('lang', 'ja')),
  components: {
    // HelloWorld
  },
  methods: {
    loadAccount(tokenval){
      const loginInfo = {
        token: tokenval
      }
      console.log('handleLogin');
      return this.$store.dispatch('tokenLogin', loginInfo)
                  .then((res) => {
            console.log('login success', loginInfo, res);
            this.$router.push({ path: '/' });
        })
        .catch((err) => {
          console.log('handleLogin err', err);
          this.$router.go({ path: '/logout', force: true });

          this.throwReject(err)
        
        })
        .finally(() => {
            console.log('handleLogin finally');
            // this.$router.go({ path: '/', force: true });
        });
    },
  },
}
</script>
